import React, { useEffect, useState, useCallback } from 'react'
import CountryPage from 'Containers/Country/Page'
import { authorization } from '../../../../Module/Auth/Auth'
import { Button } from '@material-ui/core'
import { CONFIG } from '../../../../Config/config'
import { styles } from '../../../../Components/Errors/AuthErrorModal/styles'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'
import { makeStyles } from '@material-ui/core'
import { StyledLoadingWrapper } from '../../../../Components/Campaigns/Page/Conversions/AsyncCSV/styles'

const Invoices = props => {
  const authToken = authorization.getAPIKey()
  const [isOpen, setIsOpen] = useState(false)
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [iframeSrc, setIframeSrc] = useState('')
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  const INVOICE_APP_BASE_URL = process.env.REACT_APP_INVOICE_APP_URL

  if (!INVOICE_APP_BASE_URL) {
    return (
      <CountryPage
        country={props.country}
        breadcrumbs={[{ label: 'Invoice Manager' }]}
      >
        <div className={classes.centerContainer}>
          <div className={classes.modalContent}>
            <h3 className={classes.modalText}>
              Invoice Manager is not configured.
            </h3>
          </div>
        </div>
      </CountryPage>
    )
  }

  const generateIframeUrl = useCallback(async () => {
    try {
      setIsLoading(true)
      const response = await fetch(
        `${CONFIG.API_BASE_URL}/invoice-app/generate-token`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': authToken,
          },
        },
      )
      if (!response.ok) {
        throw new Error('Failed to generate authentication token')
      }
      setIsLoading(false)

      const { token } = await response.json()
      return `${INVOICE_APP_BASE_URL}/admin#token=${encodeURIComponent(token)}`
    } catch (err) {
      throw err
    }
  }, [authToken, INVOICE_APP_BASE_URL])

  const loadIframe = useCallback(async () => {
    setIsLoading(true)
    setError(null)
    try {
      const url = await generateIframeUrl()
      setIframeSrc(url)
    } catch (err) {
      setError(`Failed to load Invoice Manager. Please try again.`)
    } finally {
      setIsLoading(false)
    }
  }, [generateIframeUrl])

  useEffect(() => {
    loadIframe()
  }, [loadIframe])

  useEffect(() => {
    const handleMessage = event => {
      if (event.origin !== new URL(INVOICE_APP_BASE_URL).origin) {
        return
      }

      try {
        if (event.data.name === 'toggleView') {
          setIsOpen(event.data.isOpen)
        }

        if (event.data && event.data.type === 'TOKEN_EXPIRED') {
          loadIframe()
        }
      } catch (error) {
        // silently handle message parsing errors
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [loadIframe, INVOICE_APP_BASE_URL])

  const handleLoad = () => {
    setIsLoading(false)
  }
  // Handle iframe error
  const handleError = () => {
    setError('Failed to load Invoice Manager')
    setIsLoading(false)
  }

  return (
    <CountryPage
      country={props.country}
      breadcrumbs={[
        {
          label: 'Invoice Manager',
        },
      ]}
    >
      {isLoading ? (
        <div style={{ paddingTop: '300px' }}>
          <StyledLoadingWrapper>
            <LoadingIndicator />
          </StyledLoadingWrapper>
        </div>
      ) : error ? (
        <div className={classes.centerContainer}>
          <div className={classes.modalContent}>
            <h3 className={classes.modalText}>{error}</h3>
            <p className={classes.modalText}>
              <Button
                onClick={loadIframe}
                className={classes.modalButton}
                style={{ color: 'white' }}
              >
                Retry
              </Button>
            </p>
          </div>
        </div>
      ) : (
        <iframe
          id="Invoice-app"
          src={iframeSrc}
          onLoad={handleLoad}
          onError={handleError}
          height="100%"
          width="100%"
          title="Promofy Invoice Manager"
          style={
            isOpen
              ? {
                  border: 'none',
                  height: 'calc(100vh - 70px)',
                  margin: '0px',
                  position: 'absolute',
                  top: '0',
                }
              : { border: 'none', height: 'calc(100vh - 292px)', margin: 0 }
          }
        />
      )}
    </CountryPage>
  )
}

export default Invoices
